export default {
  UNAUTHENTICATED: Symbol.for('UNAUTHENTICATED'),
  AUTHENTICATED: Symbol.for('AUTHENTICATED'),
};
